<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-28 19:04:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\ApprovalProcess\viewLeaveApprovalProcess.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-08 10:59:39
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_approvalProcess_form_leaveTitle')"
    backgroundClass="transparent"
    widthClass="max-1000"
    pad="0"
  >
    <template v-slot:nav-actions>
      <v-tooltip bottom v-if="can_be_cancel">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="primary mr-4"
            color="white"
            v-on="on"
            width="40"
            height="40"
            @click.stop="
              $confirmWarn(
                $t(
                  'message_essweb_LeaveApplication_form_dialog_cancelApplicationTitle'
                ),
                $t(
                  'message_essweb_LeaveApplication_form_dialog_cancelApplicationLabel'
                )
              ).then((res) => {
                if (res) toDelete(null);
              })
            "
          >
            <svg-icon size="24" fill="white" iconClass="application-cancel" />
          </v-btn>
        </template>
        <span>{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</span>
      </v-tooltip>
      <approvalTools
        v-if="Data && Data['flow_status'] == 1"
        :curUuid="Data['uuid']"
        :staff_uuid="curStaff"
        :flag="Data['cancel_flag']"
        :data_type="Data['data_type']"
        :final_node="Number(Data['is_final_task_node'])"
        :matched="Number(Data['is_match']) ? true : false"
        :canRevoke="Number(Data['is_allow_revoke'])"
        :canRollback="Number(Data['is_allow_rollback'])"
        :canForward="Number(Data['is_allow_forward'])"
        @back="onBack"
        @forward="onForward"
        @approval="onApproval"
        @reject="onReject"
      />
    </template>
    <!-- content -->
    <template v-slot:page-main v-if="Data">
      <ApprovalTriger
        v-if="Data"
        :bg-color="Data.approval_bg_color"
        :slide-color="Data.approval_tint_color"
        @triger="
          $toPage(
            '/admin/approval-process/leave-detail/' +
              $route.params.params +
              '/approval-detail/' +
              $route.params.params
          )
        "
      >
        <template v-slot:time>
          {{ $getDateTime(Data.operate_utc_datetime, "YYYY/MM/DD HH:mm") }}
        </template>
        <template v-slot:status>
          {{ $getCommonLangValue(Data.status_detail) }}
        </template>
      </ApprovalTriger>

      <Section>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_swiftNumberLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              v-model="Data.swift_number"
              :label="$t('label_essweb_leaveApplication_form_swiftNumberLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_submitDateLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="
                $getDateTime(Data.submission_utc_datetime, 'YYYY/MM/DD HH:mm')
              "
              :label="$t('label_essweb_leaveApplication_form_submitDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              label="label_essweb_leaveApplication_form_applicantLabel"
              v-model="user"
              readonly
              chips
              avatar
              two-line
              small-chips
              :items="users"
              item-value="uuid"
              item-text="preferred_name"
            >
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  :src="data.item.staff_avatar"
                  left
                  small
                  :isTemp="data.item.is_temp"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
            </AutoComplete>
          </v-col>
        </v-row>
      </Section>
      <Section>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_leaveTypeLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="
                $getCommonLangValue(Data.leave_type_name) +
                (Number(Data.cancel_flag) == 1
                  ? '(' +
                    $t('label_essweb_LeaveApplication_list_tag_cancelLabel') +
                    ')'
                  : '')
              "
              :label="$t('label_essweb_leaveApplication_form_leaveTypeLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_leaveTransactionTypeLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="$getCommonLangValue(Data.leave_transaction_type_name)"
              :label="
                $t(
                  'label_essweb_leaveApplication_form_leaveTransactionTypeLabel'
                )
              "
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_startDateLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="$getDateTime(Data.start_utc_datetime, 'YYYY/MM/DD')"
              :label="$t('label_essweb_leaveApplication_form_startDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_endDateLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="$getDateTime(Data.end_utc_datetime, 'YYYY-MM-DD')"
              :label="$t('label_essweb_leaveApplication_form_endDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_durationLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="
                parseFloat(Number(Data.total_time || 0)) +
                (Data.unit === 'D'
                  ? $t('label_essweb_system_dayLabel')
                  : Data.unit === 'H'
                  ? $t('label_essweb_system_hourLabel')
                  : '')
              "
              :label="$t('label_essweb_leaveApplication_form_durationLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_leaveReasonLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="$getCommonLangValue(Data.leave_reason_name)"
              :label="$t('label_essweb_leaveApplication_form_leaveReasonLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            cols="12"
            v-if="Data.attachments.length != 0"
          >
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_attachmentLabel")
            }}</v-sheet>
            <ImgDragUpdate :defaultImageList="Data.attachments" disabled />
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_messageLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              v-model="Data.remarks"
              :label="$t('label_essweb_leaveApplication_form_messageLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </Section>
    </template>
    <template v-slot:tools-main> </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import approvalTools from "@/Page/EssAdmin/Approval/ApprovalProcess/components/approvalTools";
export default {
  name: "viewLeaveApprovalProcess",
  components: { approvalTools },
  computed: {
    ...mapGetters(["AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
  },
  data() {
    return {
      Data: { attachments: [] },
      users: [],
      showCancelReason: false,
      showSender: false,
      reason: "",
      can_be_cancel: 0,
      curStaff: null,
      user: null,
      page_params: null,
    };
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.curStaff = this.curAppInfo["user"]["user_id"];
    this.getDetail();
  },
  filters: {
    getDuration(obj, calback) {
      return calback(obj);
    },
  },
  methods: {
    toDelete: function (reason) {
      const that = this;
      that.onDelete(that.Data.flow_status, reason);
    },
    onDelete: function (status, reason, sender) {
      const that = this;
      let url = "/approval/push/";
      let data = {
        uuid: this.Data.uuid,
        data_type: 1,
        cancel_flag: this.Data.cancel_flag,
        business_action: "cancel",
      };
      this.$Request({
        method: "POST",
        table: "x",
        url: url,
        data: data,
      }).then((res) => {
        that.$toBack();
      });
    },
    getDuration(obj) {
      let day = Number(obj["number_of_day"] || 0);
      let minutes = Number(obj["number_of_minutes"] || 0);
      var str = "";
      if (minutes == 0 && day == 0) {
        str =
          day +
          this.$t("label_essweb_system_dayLabel") +
          0 +
          this.$t("label_essweb_system_hourLabel") +
          minutes +
          this.$t("label_essweb_system_minutesLabel");
      }
      if (day > 0) {
        str += day + this.$t("label_essweb_system_dayLabel");
      }

      if (minutes > 0 && minutes < 60) {
        str += minutes + this.$t("label_essweb_system_minutesLabel");
      }
      if (minutes > 0 && minutes > 60) {
        str +=
          Math.floor(minutes / 60) +
          this.$t("label_essweb_system_hourLabel") +
          (minutes % 60) +
          this.$t("label_essweb_system_minutesLabel");
      }
      return str;
    },
    onReject: function (comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 1,
          business_action: "terminate",
          cancel_flag: this.Data.cancel_flag,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",

          text: that.$t(
            "message_essweb_approvalApplication_form_reject_rejectSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onApproval: function (comments = "", sender) {
      const that = this;
      let data = {
        uuid: this.page_params.id,
        data_type: 1,
        business_action: "send",
        cancel_flag: this.Data.cancel_flag,
        operate_comment: comments,
      };
      if (sender.length != 0) data["sender_uuid"] = sender.join(",");
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: data,
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_send_approvalSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onForward: function (sender, node, comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 1,
          business_action: "forward",
          cancel_flag: this.Data.cancel_flag,
          sender_uuid: sender,
          business_action_status: node == 0 ? 4 : 3,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",

          text: that.$t(
            "message_essweb_approvalApplication_form_forward_forwardSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onBack: function (sender, comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 1,
          cancel_flag: this.Data.cancel_flag,
          business_action: "back",
          business_action_status: sender == 0 ? 1 : 2,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_back_backSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "unknown",
        url: "/approval-task/get-approval-task-details/",
        data: {
          uuid: this.page_params.id,
          data_type: 1,
          cancel_flag: this.page_params.cancel_flag,
          is_approval: 1,
        },
      }).then((res) => {
        that.user = res.data.uuid;
        that.can_be_cancel = Number(res.data["can_it_be_cancelled"]);
        // that.curStaff = res.data["applicant_staff_uuid"];
        that.users = [
          {
            staff_avatar: res.data.agent_staff.staff_avatar,
            uuid: res.data.uuid,
            preferred_name: res.data.agent_staff.preferred_name,
          },
        ];
        if (res.data["attachments"]) {
          res.data["attachments"].map((item) => {
            item["uuid"] = item["uuid"];
            item["file_name"] = item["file_name"];
            item["path"] = item["url"];
            item["size"] = item["attachment_size"];
          });
        } else {
          res.data["attachments"] = [];
        }
        that.Data = res.data;
      });
    },
  },
};
</script>
